var map = {
	"./bigScreen0.png": "0U0F",
	"./bigScreen1.png": "ms79"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Uy3K";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/left ^\.\/bigScreen.*\.png$
// module id = Uy3K
// module chunks = 3